import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';
import WideCard from '@/modules/content/components/ContentCard/Wide';
import { WideCardContent } from '@/modules/content/components/ContentCard/Wide/renderers';
import * as Hero from '@/modules/corporate/components/DetailPageComponents/DetailHero';
import { IHeroProps } from '@/modules/corporate/components/DetailPageComponents/DetailHero/types';
import RecurringSessionIcon from '@/modules/events/components/RecurringSessionIcon';
import { EventStatusEnum, EventUnion, RecurringTypeEnum } from '@/types/schema';

import { useAdaptEvent } from '../../../event/config';
import { EventCardProps } from '../types';
import { dateStampStyles } from './styles';

const renderImageIcon = () => (
  <Hero.DateStamp className={cn('absolute top-8 z-10 origin-top-right end-8', dateStampStyles)} />
);

function EventPreviewCard(props: EventCardProps) {
  const { className, imageProps, disabled, renderInfo } = props;
  const content = useAdaptEvent(props.content as any);
  const { isMobile } = useScreen();

  return (
    <Hero.Main content={content as IHeroProps}>
      <WideCard hideBookmark className={className} content={content} disabled={disabled}>
        <WideCardContent
          imageProps={imageProps}
          renderImageIcon={
            disabled || (props.content.event as EventUnion)?.status === EventStatusEnum.Completed
              ? undefined
              : renderImageIcon
          }
          renderInfo={renderInfo}
          renderName={() => {
            const Name = (
              <BaseCard.Name
                className="mt-4 flex-shrink xs:mt-0"
                numberOfLines={isMobile ? 2 : 1}
              />
            );

            if (!props.content.event) {
              return Name;
            }

            return (props.content.event as EventUnion).recurringCategory !==
              RecurringTypeEnum.Recurring ? (
              Name
            ) : (
              <Stack alignItems="center" gapX={8}>
                {Name}
                <RecurringSessionIcon className="mt-4" />
              </Stack>
            );
          }}
        />
      </WideCard>
    </Hero.Main>
  );
}

export default EventPreviewCard;
